module.exports = ".imageLayout {\n    width: 100%;\n    height: 80px;\n    background-color: #F8FAFB;\n    border: 4px dashed #DCD9DB;\n    /*padding: 0 8px;*/\n    line-height: 55px;\n}\n\n.imageLayout span {\n    /*line-height: 40px;*/\n    /*cursor: pointer;*/\n    /*padding: 0;*/\n    /*background-color: #FFF;*/\n    /*color: #BCC0C7;*/\n    /*border: 1px solid #BCC0C7;*/\n}\n\n.borderB {\n    /*border-bottom: 1px solid #edf0f4;*/\n}\n\n.borderB .geo-send-file {\n    width: 100%;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/bens/frotas/frota-odometro-horimetro/frota-odometro-horimetro.component.css
 ** module id = 453
 ** module chunks = 0
 **/